export default __webpack_public_path__ + "static/media/announcement-highlighted.b06853e8.svg";